﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

// This file contains a password field.

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { Input, NormalizerResult } from "~base/Components/Primitives/Input";
import { PasswordInputProps } from "./PasswordInputTypes";

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

const PasswordInput: React.FunctionComponent<PasswordInputProps> = (
    props: PasswordInputProps
) => {
    const {
        constComponentId,
        value,
        setValue,
        isValid,
        validateInitialValue = true,
        normalizer,
        type = "Password",
        maxLength,
        placeholder = "",
        displayValueFormat,
    } = props;

    const setTextValue = (val: string) => {
        if (setValue) {
            setValue(val);
        }
    };

    const isTextValid = (val: string): boolean => {
        if (isValid) {
            return isValid(val);
        }
        return true;
    };

    const textNormalizer = (
        val: string,
        final: boolean,
        previousValue: string,
        lastKeyPressed: string
    ): NormalizerResult => {
        let cleanValue = val;
        if (normalizer) {
            cleanValue = normalizer(
                cleanValue,
                final,
                previousValue,
                lastKeyPressed
            ).result;
        }

        return {
            result:
                cleanValue.length < maxLength || !maxLength
                    ? cleanValue
                    : cleanValue.substring(0, maxLength),
        };
    };

    const getPlaceholder = () => {
        return placeholder;
    };

    const formatValue = (val: string) => {
        return val;
    };

    return (
        <Input
            {...props}
            constComponentId={constComponentId}
            isValid={isTextValid}
            validateInitialValue={validateInitialValue}
            normalizer={textNormalizer}
            value={value}
            setValue={setTextValue}
            type={type}
            placeholder={getPlaceholder()}
            displayValueFormat={displayValueFormat ?? formatValue}
        />
    );
};

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------
export default PasswordInput;
export { PasswordInput };
